import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import { BspData } from '../types';
import { ModelOptions } from '../../../types';
import { Voucher } from '../../vouchers/types';

export type GetBspData<T> = (
    params?: Partial<T & { queryPresets: string; queryPresetsProps: { [key: string]: any } }>,
    options?: ModelOptions,
    updateState?: boolean
) => Promise<Array<T>>;

interface Context<T> {
    get: GetBspData<T>;
    getOne: (params: { _id: BspData['_id'] }, body?: { populateQuery: Array<any> }) => Promise<T>;
    post: (body: Partial<T>, updateState?: boolean, last?: boolean) => Promise<T>;
    put: (body: Partial<T>) => Promise<T>;
    remove?: (id: string) => Promise<string>;
    softDelete: (body: { _id: string }) => Promise<any>;
    data: T[];
    setData: (array: Array<T>) => void;
    selected: T | null;
    setSelected: (object: T) => void;
    error?: T | null | {};
}

export type MatchWithVoucherBody = {
    voucher: Voucher;
    bspTickets?: BspData[];
};

export interface ExtendedContext extends Context<BspData> {
    uploadDataFromFile: (body: Array<Partial<BspData>>) => Promise<Array<BspData>>;
    matchWithVoucher: (body: MatchWithVoucherBody) => Promise<Array<BspData>>;
    query: (query: any) => Promise<Array<BspData>>;
    updateDocumentApproval: (documentId: string, isApproved: boolean) => Promise<any>;
}

export default createContext<ExtendedContext>({
    get: api.get,
    getOne: api.getOne,
    post: api.post,
    put: api.put,
    remove: api.remove,
    softDelete: api.softDelete,
    data: [],
    setData: noop,
    selected: null,
    setSelected: noop,
    error: null,
    uploadDataFromFile: api.uploadDataFromFile,
    matchWithVoucher: api.matchWithVoucher,
    query: api.query,
    updateDocumentApproval: api.updateDocumentApproval
});
